module.exports = __webpack_public_path__ + "static/media/Peter_Seger_Resume.a4e62b53.pdf";